import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e994764"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nav-name" }, "用户管理"),
  /*#__PURE__*/_createElementVNode("a", { href: "#/customer_views" }, "返回旧版")
], -1))
const _hoisted_3 = { class: "menu-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (d) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "menu-item",
          "active-class": "custom-main-bgcolor",
          to: "/fe-subapp/index/" + d.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.menuFilter(d.title)), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256))
    ])
  ]))
}